interface StepperProps {
  steps: { id: string; label: string }[];
  currentIndex: number;
  onStepClick?: (index: number) => void;
}

export function Stepper({ steps, currentIndex, onStepClick }: StepperProps) {
  return (
    <ol className="stepper" aria-label="Onboarding-Fortschritt">
      {steps.map((step, idx) => {
        const status = idx < currentIndex ? 'done' : idx === currentIndex ? 'current' : 'todo';
        const clickable = onStepClick && idx <= currentIndex;
        return (
          <li key={step.id} className={`stepper-item is-${status}`}>
            <button
              type="button"
              className="stepper-bubble"
              onClick={clickable ? () => onStepClick(idx) : undefined}
              disabled={!clickable}
              aria-current={status === 'current' ? 'step' : undefined}
            >
              {status === 'done' ? '✓' : idx + 1}
            </button>
            <span className="stepper-label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
